module.exports = __webpack_public_path__ + "static/media/multipostingHelper2.d2819581.png";